<template>
  <div class='VerifyCode'>
    <div class="cont" v-if="!load">
      <div class="desc">Inseira o código enviado para o seu email</div>
      <input-verify-code @returnValue="value => {
        errMsg = ''
        code = value
      }"/>
      <div class="cont-btn">
        <button @click="run">verificar</button>
      </div>
      <div class="err-msg">{{ errMsg }}</div>
    </div>
    <div v-if="load">
      <vue-spinner size="40px"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputVerifyCode from './InputVerifyCode'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'VerifyCode',
  components: { InputVerifyCode, VueSpinner },
  data () {
    return {
      load: false,
      code: '',
      errMsg: ''
    }
  },
  computed: {
    ...mapGetters(['PWrecovery'])
  },
  methods: {
    ...mapActions(['GetCodeVerify']),
    run () {
      if(this.code.length < 6) {
        this.errMsg = 'Código de verificação obrigatório'
        return
      }
      this.load = true
      setTimeout(() => {
        this.GetCodeVerify({ email: this.PWrecovery.email, codigo: this.code })
          .then(res => {
            if(res.status) {
              this.$router.push('/pwrecovery/input')
              return
            }
            this.code = ''
            this.load = false
            this.errMsg = res.message
          })
      }, 2000)
    }
  }
}
</script>

<style scoped>
.VerifyCode {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.desc {
  width: 350px;
  margin: auto;
}

button {
  border: 0;
  width: 338px;
  height: 30px;
  cursor: pointer;
  background-color: #333333;
  color: #EEEEEE;
  font-size: 14px;
  border-radius: 5px;
  display: block;
  margin: auto;
}

button:hover {
  background-color: #4E4A4A;
}

.err-msg {
  width: 408px;
  height: 30px;
  margin: auto;
  margin-top: 10px;
  color: #6E2E2F;
  font-size: 14px;
}
</style>
